import { motion } from 'framer-motion'
import { capabilities } from '@/data/services'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function Capabilities() {
  return (
    <section id="capacidades" className="py-20 md:py-28 bg-secondary/30 border-y border-border/30">
      <div className="container">
        <div className="max-w-2xl mx-auto text-center mb-16">
          <div className="text-sm font-semibold tracking-wider text-brand-cyan uppercase mb-3">
            O que fazemos
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-balance">
            Três pilares que se complementam
          </h2>
          <p className="mt-4 text-lg text-muted-foreground text-pretty">
            Consultoria, engenharia e formação — combinamos os 3 ou trabalhamos isolado, do jeito que o projeto exigir.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {capabilities.map((cap, i) => (
            <motion.div
              key={cap.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <Card className="h-full hover:border-brand-cyan/60 hover:shadow-xl hover:shadow-brand-cyan/10 hover:-translate-y-1 group transition-all duration-300">
                <CardHeader>
                  <div className="size-12 rounded-lg bg-brand-gradient flex items-center justify-center mb-4 shadow-lg shadow-brand-purple/30">
                    <cap.icon className="size-6 text-white" />
                  </div>
                  <CardTitle>{cap.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-pretty">
                    {cap.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
